import * as React from 'react'
import type {SVGProps} from 'react'
const SvgIconLoyalty3StepShop = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={68} height={69} viewBox="0 0 68 69" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#142745"
                strokeLinecap="round"
                strokeWidth={2.434}
                d="M43.179 17.714V14.12C43.179 7.427 37.749 2 31.052 2S18.925 7.427 18.925 14.12v3.594"
            />
            <path
                stroke="#142745"
                strokeLinejoin="round"
                strokeWidth={2.434}
                d="M4.426 67h59.148a2.425 2.425 0 0 0 2.405-2.74l-5.832-44.437a2.424 2.424 0 0 0-2.405-2.11H10.258a2.425 2.425 0 0 0-2.405 2.11L2.021 64.26A2.425 2.425 0 0 0 4.426 67Z"
            />
            <path
                stroke="#142745"
                strokeWidth={2.434}
                d="m14.433 67-1.516-46.217a2.973 2.973 0 0 1 2.971-3.07h7.08"
            />
            <path
                stroke="#142745"
                strokeLinecap="round"
                strokeWidth={2.434}
                d="M49.646 26.24V14.12C49.646 7.426 44.216 2 37.52 2S25.392 7.426 25.392 14.12v12.12"
            />
            <path
                fill="#E1F3EF"
                d="m36.474 58.612 8.569-8.563a6.003 6.003 0 0 0 0-8.492 6.01 6.01 0 0 0-8.498 0l-8.914 8.909a.317.317 0 0 0 0 .45l7.7 7.696a.81.81 0 0 0 1.143 0"
            />
            <path
                fill="#E1F3EF"
                d="m35.33 58.612-8.568-8.563a6.003 6.003 0 0 1 0-8.492 6.01 6.01 0 0 1 8.498 0l8.914 8.909a.317.317 0 0 1 0 .45l-7.7 7.696a.81.81 0 0 1-1.143 0"
            />
            <path
                fill="#142745"
                d="m38.091 55.138 8.569-8.564a6.003 6.003 0 0 0 0-8.492 6.01 6.01 0 0 0-8.498 0l-8.914 8.909a.32.32 0 0 0 0 .451l7.7 7.696a.81.81 0 0 0 1.143 0"
            />
            <path
                fill="#142745"
                d="m36.948 55.138-8.568-8.564a6 6 0 0 1 0-8.492 6.01 6.01 0 0 1 8.497 0l8.914 8.909a.32.32 0 0 1 0 .451l-7.7 7.696a.81.81 0 0 1-1.143 0"
            />
        </g>
    </svg>
)
export default SvgIconLoyalty3StepShop
